import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { addCustomerEffect } from '../_effects';
import { alertActions } from './alertActions';

export const addCustomerActions = {
  addCustomer,
  uploadMedia,
  getIDType,
  getProfession,
};

function addCustomer(customer) {
  return (dispatch) => {
    dispatch(request(customer));
    addCustomerEffect.addCustomer(customer).then(
      (res) => {
        dispatch(success(res));
        localStorage.setItem('CustomerCode', JSON.stringify(res.data.response.CustomerCode));
        // if (customer.data.statusCode == '401') {
        //   history.push('/add-customer');
        // }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(customer) {
    return { type: userConstants.CUSTOMER_REQUEST, customer };
  }
  function success(customer) {
    return { type: userConstants.CUSTOMER_SUCCESS, customer };
  }
  function failure(error) {
    return { type: userConstants.CUSTOMER_FAILURE, error };
  }
}

function uploadMedia(upload) {
  return (dispatch) => {
    dispatch(request(upload));
    addCustomerEffect.addCustomer(upload).then(
      (upload) => {
        dispatch(success(upload));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(upload) {
    return { type: userConstants.UPLOAD_MEDIA_REQUEST, upload };
  }
  function success(upload) {
    return { type: userConstants.UPLOAD_MEDIA_SUCCESS, upload };
  }
  function failure(error) {
    return { type: userConstants.UPLOAD_MEDIA_FAILURE, error };
  }
}

function getIDType(getId) {
  return (dispatch) => {
    dispatch(request(getId));
    addCustomerEffect.getIDType(getId).then(
      (getId) => {
        dispatch(success(getId));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(getId) {
    return { type: userConstants.GET_ID_TYPE_REQUEST, getId };
  }
  function success(getId) {
    return { type: userConstants.GET_ID_TYPE_SUCCESS, getId };
  }
  function failure(error) {
    return { type: userConstants.GET_ID_TYPE_FAILURE, error };
  }
}

function getProfession(profession) {
  return (dispatch) => {
    dispatch(request(profession));
    addCustomerEffect.getProfession(profession).then(
      (profession) => {
        dispatch(success(profession));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(profession) {
    return { type: userConstants.GET_PROFESSION_REQUEST, profession };
  }
  function success(profession) {
    return { type: userConstants.GET_PROFESSION_SUCCESS, profession };
  }
  function failure(error) {
    return { type: userConstants.GET_PROFESSION_FAILURE, error };
  }
}

// import ActionUtility from '../../utilities/ActionUtility';

// export const registerActions = {
//     register,
//   requestError
// }
//    const REQUEST_SHOW = 'ShowsAction.REQUEST_SHOW';
//    const REQUEST_SHOW_FINISHED = 'ShowsAction.REQUEST_SHOW_FINISHED';

//    const REQUEST_EPISODES = 'ShowsAction.REQUEST_EPISODES';
//    const REQUEST_EPISODES_FINISHED = 'ShowsAction.REQUEST_EPISODES_FINISHED';

//    const REQUEST_CAST = 'ShowsAction.REQUEST_CAST';
//    const REQUEST_CAST_FINISHED = 'ShowsAction.REQUEST_CAST_FINISHED';

//    const REQUEST_ERROR = 'ShowsAction.REQUEST_ERROR';
//    const REQUEST_ERROR_FINISHED = 'ShowsAction.REQUEST_ERROR_FINISHED';

//    function register() {
//     return async (dispatch, getState) => {
//         console.log(getState());
//       const showId = getState().regMobile;

//       await ActionUtility.createThunkEffect(dispatch, registerActions.REQUEST_SHOW, registerEffect.registerSet, showId);
//     };
//   }

//    function requestError() {
//     return async (dispatch, getState) => {
//       await ActionUtility.createThunkEffect(dispatch, registerActions.REQUEST_ERROR, registerEffect.requestError);
//     };
//   }
